import { utils } from '@hh/global.js'
const { updateCart } = utils

class GiftNote extends HTMLElement {
  constructor() {
    super()

    this.textarea = this.querySelector('textarea')
    this.charCount = this.querySelector('.js-char-count')
    this.submit = this.querySelector('.js-submit')
    this.remove = this.querySelector('.js-remove')

    this.addCopyElement = document.querySelector(
      '.gift-note__trigger-text--add'
    )
    this.editCopyElement = document.querySelector(
      '.gift-note__trigger-text--edit'
    )

    this.handleSubmit = this.handleSubmit.bind(this)

    this.textarea.addEventListener(
      'input',
      this.handleCharacterCount.bind(this)
    )
    this.submit.addEventListener('click', () => this.handleSubmit('submit'))
    this.remove.addEventListener('click', () => this.handleSubmit('remove'))

    this.updateTriggerCopy()
  }

  handleCharacterCount(e) {
    this.charCount.innerHTML = e.target.value.length
    this.updateTriggerCopy()
  }

  async handleSubmit(source) {
    if (source == 'remove') {
      this.textarea.value = ''
      this.charCount.innerHTML = 0
    }

    const body = {
      note: source == 'submit' ? this.textarea.value : '',
    }

    await updateCart(body)
    this.updateTriggerCopy()
    this.closest('hh-drawer').close()
  }

  updateTriggerCopy() {
    if (this.textarea.value.trim()) {
      this.addCopyElement.classList.remove('visible')
      this.editCopyElement.classList.add('visible')
    } else {
      this.addCopyElement.classList.add('visible')
      this.editCopyElement.classList.remove('visible')
    }
  }
}

customElements.define('hh-gift-note', GiftNote)
